module.exports = __webpack_public_path__ + "static/media/PWN.9c1d6845.jpg";